import { EHideOfferState } from '../store/hide_offer';

export const parseHash = (hash: string): { [key: string]: string } => {
  const result: { [key: string]: string } = {};
  if (hash.includes('HIDE')) {
    result['HIDE'] = hash.includes('HIDE_SUCCES') ? EHideOfferState.SUCCESS : EHideOfferState.ERROR;
  }

  return result;
};
